// extracted by mini-css-extract-plugin
export default {"client-dashboard":"styles_client-dashboard__nFwbQ"};